import * as React from "react"
import { GiMicrophone } from "react-icons/gi"
import { MdOutlineGroups } from "react-icons/md"
import { TbSparkles } from "react-icons/tb"
import { Box, Center, SimpleGrid, Stack, Text, useColorModeValue } from "@chakra-ui/react"

export function Benefits() {
  const color = useColorModeValue("gray.700", "gray.400")
  return (
    <Center role="region" aria-label="Benefits section">
      <Stack spacing={10} textAlign="center" alignItems="center">
        <Stack spacing={{ base: 2, md: 0 }} alignItems="center" pb={8}>
          <Text
            as="h3"
            fontSize={{ base: "4xl", md: "4xl" }}
            fontWeight={900}
            px={{ base: 2, md: 48 }}
            lineHeight={{ base: "shorter", md: "short" }}
            id="benefits-heading"
          >
            Meld je gratis aan
          </Text>
          <Text
            as="h4"
            color={color}
            fontSize={{ base: "xl", md: "2xl" }}
            px={{ base: 2, md: 32 }}
            lineHeight="short"
            aria-labelledby="benefits-heading"
          >
            Probeer nieuwe dingen, krijg tips van makers en ontmoet jongeren die graag iets maken. Of je nu
            pas begint of al volop bezig bent.
          </Text>
        </Stack>

        <SimpleGrid 
          columns={{ base: 1, md: 3 }} 
          spacing={10}
          role="list"
          aria-label="List of benefits"
        >
          <Stack spacing={4} alignItems="center" role="listitem">
            <Box as={TbSparkles} size={90} aria-hidden="true" />
            <Text fontWeight={900} fontSize="2xl" as="h5">
              Probeer iets nieuws
            </Text>
            <Text fontSize="md" color={color}>
              Volg gratis workshops, krijg coaching en ga mee achter de schermen.
            </Text>
          </Stack>
          <Stack spacing={4} alignItems="center" role="listitem">
            <Box as={GiMicrophone} size={90} aria-hidden="true" />
            <Text fontWeight={900} fontSize="2xl" as="h5">
              Pak het podium
            </Text>
            <Text fontSize="md" color={color}>
              Doe mee aan een voorronde bij jou in de buurt. Ook als je het spannend vindt. Je krijgt
              feedback van een jury.
            </Text>
          </Stack>
          <Stack spacing={4} alignItems="center" role="listitem">
            <Box as={MdOutlineGroups} size={90} aria-hidden="true" />
            <Text fontWeight={900} fontSize="2xl" as="h5">
              Maak het samen
            </Text>
            <Text fontSize="md" color={color}>
              Je bent niet de enige: bijna 6000 jongeren zijn member van Kunstbende. Ontmoet andere makers en
              probeer samen iets nieuws.
            </Text>
          </Stack>
        </SimpleGrid>
      </Stack>
    </Center>
  )
}
